export const defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map